import z from 'zod';

export const userCacheSchema = z.object({
  userId: z.string(),
  idToken: z.string(),
  email: z.string(),
});

export interface UserCache extends z.infer<typeof userCacheSchema> {}
